/**
 * Configuration Tealium isolée de apiConfig.
 *
 * apiConfig est progressivement déprécié dans le projet et ne doit pas
 * recevoir de nouvelles intégrations. Les variables Tealium n'utilisent pas de
 * suffixes _DEV / _STAGING : l'environnement de déploiement fournit directement
 * les bonnes valeurs.
 */

export const tealiumConfig = {
  // Valeurs par défaut fournies par Vodafone pour TRACE+.
  account: process.env.GATSBY_TEALIUM_ACCOUNT || 'vodafone',
  profile: process.env.GATSBY_TEALIUM_PROFILE || 'za-traceplus-main',
  env: process.env.GATSBY_TEALIUM_ENV || 'prod',
  // Purpose Didomi optionnel qui conditionne le chargement.
  purposeId: process.env.GATSBY_TEALIUM_PURPOSE_ID || '',
  parentDomain: process.env.GATSBY_TEALIUM_PARENT_DOMAIN || 'trace+',
  defaultCountry:
    process.env.GATSBY_TEALIUM_DEFAULT_COUNTRY || 'south africa',
  debug: process.env.GATSBY_ENV_MODE !== 'prod',
};

export type TealiumConfig = typeof tealiumConfig;
